import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { PlayCircle } from 'lucide-react';
import { projects } from '../mock';

const Projects = () => {
  const [filter, setFilter] = useState('All');
  const categories = ['All', 'Video Art', 'Performance', 'Digital Art', 'Mixed Media', 'Jewelry'];

  const filteredProjects = filter === 'All' 
    ? projects 
    : projects.filter(p => p.category === filter);

  return (
    <div className="min-h-screen bg-off-white py-20 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-charcoal mb-4">
            Projects
          </h1>
          <p className="text-lg text-neutral-700 max-w-3xl">
            An interdisciplinary body of work exploring ADOS identity, Wake Work, ancestry, and material practice through video, performance, digital art, and fabrication.
          </p>
        </div>

        {/* Filter Buttons */}
        <div className="flex flex-wrap gap-3 mb-12">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setFilter(category)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
                filter === category
                  ? 'bg-copper text-charcoal'
                  : 'bg-warm-grey text-charcoal hover:bg-copper hover:text-charcoal'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Projects Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProjects.map((project) => (
            <Link to={`/projects/${project.id}`} key={project.id}>
              <div className="group cursor-pointer">
                <div className="relative aspect-square mb-4 overflow-hidden rounded-lg bg-off-white">
                  <img
                    src={project.thumbnail}
                    alt={project.title}
                    className="w-full h-full object-contain transition-transform duration-300 group-hover:scale-105"
                  />
                  {project.videoUrl && (
                    <div className="absolute inset-0 flex items-center justify-center bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity">
                      <PlayCircle className="h-16 w-16 text-off-white" />
                    </div>
                  )}
                  <div className="absolute top-3 right-3">
                    <span className="bg-charcoal text-off-white px-3 py-1 rounded-full text-xs font-medium">
                      {project.category}
                    </span>
                  </div>
                </div>
                <h3 className="text-xl font-semibold text-charcoal mb-2 group-hover:text-copper transition-colors">
                  {project.title}
                </h3>
                <p className="text-neutral-600">
                  {project.year} • {project.medium}
                  {project.duration && ` • ${project.duration}`}
                </p>
                <p className="text-neutral-700 mt-2 text-sm line-clamp-2">
                  {project.description}
                </p>
              </div>
            </Link>
          ))}
        </div>

        {filteredProjects.length === 0 && (
          <div className="text-center py-20">
            <p className="text-neutral-600 text-lg">No projects found in this category.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Projects;